import React from 'react';
import { AdIcons } from './Ad';
import SienBanner from './SienBanner';
import StainedGlass from './StainedGlass';
import './ArticleSidebars.css';

export default function ArticleSidebars() {
  return (
    <>
      <div className="left-area article-ad-sidebar">
        <AdIcons />
      </div>
      <div className="right-area stained-glass-sidebar">
        <SienBanner />
        <StainedGlass />
      </div>
    </>
  );
}
